import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')(() => ({
  position: 'relative',
  marginBottom: 140,
  paddingTop: 30,
}));

export const SliderWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginLeft: `-${theme.pageMarginHorizontalMobile}`,
    marginRight: `-${theme.pageMarginHorizontalMobile}`,
  },
}));
